/* eslint-env browser, es6 */
import m from "mithril";

import { Duel, DuelResult } from "../api";

interface DuelResultsViewAttrs {
  duel: Duel;
  nickname: string;
}

export class DuelResultsView implements m.Component<DuelResultsViewAttrs> {
  view(vnode: m.Vnode<DuelResultsViewAttrs>): m.Children {
    const results = vnode.attrs.duel.results.slice();
    results.sort(
      (result1: DuelResult, result2: DuelResult) =>
        result2.score - result1.score
    );
    return m("div.duel-results", [
      m("h2", "Duel results"),
      results.length > 0
        ? [
            m(
              "ol",
              results.map((result) =>
                m(
                  "li",
                  m("span.flex", [
                    result.nickname === vnode.attrs.nickname
                      ? m("span.self", result.nickname)
                      : result.nickname,
                    m("span.score", result.score),
                  ])
                )
              )
            ),
            m(
              "p.refresh-the-page",
              "Refresh the page to check for more results."
            ),
          ]
        : m("p", "No one else has played yet. Send them the link!"),
    ]);
  }
}
